<template>
    <div class="elementor-element elementor-element-fc0934c elementor-button-align-stretch elementor-widget elementor-widget-form">
        <div class="elementor-widget-container">
            <form v-if="show" class="elementor-form" method="post" @submit.prevent="submit">
                <div class="elementor-form-fields-wrapper elementor-labels-above">
                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-50">
                        <input size="1" type="text"
                               name="firstname" v-model="model.firstname"
                               class="elementor-field elementor-size-sm  elementor-field-textual"
                               placeholder="First Name" onfocus="this.select()">
                    </div>
                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_658d00c elementor-col-50">
                        <input size="1" type="text"
                               name="lastname" v-model="model.lastname"
                               class="elementor-field elementor-size-sm  elementor-field-textual"
                               placeholder="Last Name" onfocus="this.select()">
                    </div>
                    <div class="elementor-field-type-email elementor-field-group elementor-column elementor-field-group-email elementor-col-50 elementor-field-required">
                        <input size="1" type="email"
                               name="email" v-model="model.email"
                               class="elementor-field elementor-size-sm  elementor-field-textual"
                               placeholder="Email Address" required="required"
                               aria-required="true" onfocus="this.select()">
                    </div>
                    <div class="elementor-field-type-tel elementor-field-group elementor-column elementor-field-group-field_5892e60 elementor-col-50 elementor-field-required">
                        <input size="1" type="tel"
                               name="phone" v-model="model.phone"
                               class="elementor-field elementor-size-sm  elementor-field-textual"
                               placeholder="Phone Number" required="required"
                               aria-required="true" pattern="[0-9()+-.]+" onfocus="this.select()"
                               title="Only numbers and phone characters (#, -, *, etc) are accepted.">

                    </div>
                    <div class="elementor-field-type-textarea elementor-field-group elementor-column elementor-field-group-message elementor-col-100">
                        <label for="form-field-message"
                               class="elementor-field-label">
                            Message
                        </label>
                        <textarea class="elementor-field-textual elementor-field  elementor-size-sm"
                                  v-model="model.message"
                                  rows="6"
                                  placeholder="Type your message here"></textarea>
                    </div>
                    <div class="elementor-field-group elementor-column elementor-field-group-message elementor-col-100">
                        <div id="captcha" class="ms-auto"></div>
                    </div>
                    <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-50 e-form__buttons offset-6">
                        <button type="submit" @click.prevent="submit"
                                class="elementor-button elementor-size-sm">
                            <span>
                                <span class="elementor-button-icon"></span>
                                <span class="elementor-button-text">Send</span>
                            </span>
                        </button>
                    </div>
                </div>
            </form>
            <div v-else class="alert alert-success">
                Message sent!
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import Messages from '../common/Messages'

    export default {
        props: ['values'],
        data: function () {
            return {
                model: {
                    id: '',
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    message: '',
                    form: '',
                    referrer: '',
                    token: '',
                },
                show: true,
            };
        },
        methods: {
            submit() {
                const vm = this;
                axios.post('/forms/submit', this.model)
                    .then(r => {
                        if (r.data.success) {
                            vm.show = false;
                        } else if (r.data.message) {
                            Messages.warning({ html: r.data.message });
                        }
                    })
                    .catch(e => {
                        Messages.warning();
                    });
            }
        },
        created() {
            this.model.firstname = this.values.firstname;
            this.model.lastname = this.values.lastname;
            this.model.email = this.values.email;
            this.model.phone = this.values.phone;
            this.model.id = this.values.id;
            this.model.form = this.values.form ?? 'contact';
            this.model.referrer = window.location.href;
        },
        mounted() {
            const vm = this;
            window.tsloaded = function () {
                turnstile.render("#captcha", {
                    appearance: 'interaction-only',
                    language: 'en',
                    sitekey: "0x4AAAAAAAklVZV-Sakz91WP",
                    theme: 'light',
                    callback: function (token) {
                        vm.model.token = token;
                    },
                });
            };
            const s = document.createElement('script');
            s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=tsloaded';
            document.body.appendChild(s);
        }
    }
</script>